import { Icon, Layout, Menu, message } from 'antd';
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { config } from '../../config';
import { userManager } from '../../services/user';
import { UserPermission } from '../rolePermission/type';
import { SUBMENUS } from './constant';

interface SubNumeItem {
  id: number;
  name: string;
  route: string;
  isShow: boolean;
}
interface Submenu {
  id: number;
  icon: string;
  name: string;
  isShow: boolean;
  items: SubNumeItem[];
}

const { Sider } = Layout;

const Logo = styled.div`
  padding: 16px 24px;
  background: #002140;
  color: #fff;
  line-height: 32px;
  font-size: 24px;
  height: 64px;
  img {
    height: 32px;
    margin-right: 16px;
    vertical-align: bottom;
  }
  a {
    color: #fff;
    text-decoration: none;
  }
`;

interface Props {
  collapsed: boolean;
  pathname: string;
}
interface State {
  includeStateSubmenus?: Submenu[];
}
export class CrmSideMenu extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    if (config.DEBUG) {
      const includeStateSubmenus: Submenu[] = SUBMENUS.map(submenu => {
        const items = submenu.items.map(item => {
          if (!item.permissions || (item.permissions && item.permissions.length === 0)) {
            message.error('没有配置任何权限 请联系管理员');
            throw new Error('submenu item permissions config error!');
          }
          const newItem = { ...item, isShow: true };
          return newItem;
        });
        const newSubmenu = { items, isShow: true, id: submenu.id, icon: submenu.icon, name: submenu.name };
        return newSubmenu;
      });
      this.setState({
        includeStateSubmenus,
      });
      return;
    }

    const user = userManager.getUser();
    if (!user) {
      return;
    }

    const { roles = [] } = user;
    if (roles.length === 0) {
      return;
    }

    let userPermissions: UserPermission[] = [];
    if (roles.length > 1) {
      // 数组合并并去重
      const permissionsMap = new Map();
      roles.forEach(role => {
        role.permissions.forEach(permission => {
          permissionsMap.set(permission.id, permission);
        });
      });
      userPermissions = Array.from(permissionsMap.values());
    } else {
      userPermissions = roles[0].permissions;
    }

    let includeStateSubmenus: Submenu[] = [];
    if (userPermissions && userPermissions.length > 0) {
      includeStateSubmenus = SUBMENUS.map(submenu => {
        const items = submenu.items.map(item => {
          if (!item.permissions || (item.permissions && item.permissions.length === 0)) {
            message.error('没有配置任何权限 请联系管理员');
          }

          const isShowArray = item.permissions.map(itemPermission => {
            const isShow = userPermissions.some(
              userPermission =>
                userPermission.action === itemPermission.action && userPermission.resource === itemPermission.resource,
            );
            return isShow;
          });

          const isShow = !isShowArray.some(value => !value);
          const newItem = { ...item, isShow };
          return newItem;
        });
        const isShow = items.some(item => item.isShow);
        const newSubmenu = { items, isShow, id: submenu.id, icon: submenu.icon, name: submenu.name };
        return newSubmenu;
      });
    }

    this.setState({
      includeStateSubmenus,
    });
  }

  render() {
    const { collapsed, pathname } = this.props;
    const { includeStateSubmenus } = this.state;
    const key = pathname.split('/')[1];
    const defaultOpenSubmenu = SUBMENUS.find(submenu => {
      const item = submenu.items.find(item => item.route.split('/')[1] === key);
      if (item) {
        return submenu;
      }
      return undefined;
    });
    return (
      <Sider trigger={null} collapsible collapsed={collapsed} style={{ height: '100vh', overflowY: 'auto' }}>
        <Logo>
          <Link to="/">
            <img src={require('./favicon.png')} />
            {!collapsed && '聪明派'}
          </Link>
        </Logo>

        {includeStateSubmenus ? (
          <Menu
            theme="dark"
            defaultOpenKeys={defaultOpenSubmenu && [`${defaultOpenSubmenu.id}`]}
            selectedKeys={[key]}
            mode="inline"
          >
            {includeStateSubmenus.map(submenu => {
              if (submenu.isShow) {
                return (
                  <Menu.SubMenu
                    key={`${submenu.id}`}
                    title={
                      <span>
                        <Icon type={submenu.icon} />
                        <span>{submenu.name}</span>
                      </span>
                    }
                  >
                    {submenu.items.map(item => {
                      if (item.isShow) {
                        return (
                          <Menu.Item key={item.route.split('/')[1]}>
                            <Link to={item.route}>{item.name}</Link>
                          </Menu.Item>
                        );
                      }
                      return;
                    })}
                  </Menu.SubMenu>
                );
              }
              return;
            })}
          </Menu>
        ) : (
          <div>loading...</div>
        )}
      </Sider>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/layouts/CrmSideMenu.tsx